import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/icon/top-bar-close-icon.svg'
import _imports_1 from '../assets/images/icon/logo-icon.svg'
import _imports_2 from '../assets/images/icon/hamburger-mobile-icon.svg'
import _imports_3 from '../assets/images/icon/cross-mobile-icon.svg'
import _imports_4 from '../assets/images/icon/dropdown-close-icon.svg'
import _imports_5 from '../assets/images/console.png'
import _imports_6 from '../assets/images/icon/dropdowm-right-arrow.svg'
import _imports_7 from '../assets/images/icon/arrow-forward-icon.svg'
import _imports_8 from '../assets/images/icon/headere-contact-btn-icon.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Join our discord community to chat with the team.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://discord.gg/7M84Xp8QBr",
  target: "_blank",
  class: "btn-style top-btn"
}, "Discord", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "top-bar-close-icon"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12 col-lg-3 align-self-center" }
const _hoisted_9 = { class: "logo-wrapper" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "logocloud",
  src: _imports_1,
  alt: "logo-icon"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "hamburger-mobile-icon"
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "col-md-6 align-self-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "cross-mobile-icon"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "menu" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Products", -1)
const _hoisted_18 = { class: "container ex-large" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "dropdown-close"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: "dropdown-close-icon"
  })
], -1)
const _hoisted_20 = { class: "row" }
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-4\"><div class=\"main-img-wrapper\"><div class=\"img-wrapper\"><img src=\"" + _imports_5 + "\" alt=\"blog-img-1\"></div><div class=\"content-wrapper\"><a href=\"https://console.cloudblast.io/\"><p>Try our new console</p><img src=\"" + _imports_6 + "\" alt=\"dropdowm-right-arrow\" class=\"right-arrow\"></a></div></div></div>", 1)
const _hoisted_22 = { class: "col-md-8" }
const _hoisted_23 = { class: "right-content-wrapper" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "heading" }, [
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("Discover our wide range of services "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_7,
      alt: "arrow-forward-icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "Welcome! Begin your experience with our amazing cloud.")
], -1)
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Cloud Servers (VPS)"),
  /*#__PURE__*/_createElementVNode("p", null, "Explore our affordable plans tailored for diverse customer needs and budgets.")
], -1)
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Blog"),
  /*#__PURE__*/_createElementVNode("p", null, "Dive into engaging articles, latest updates, and industry insights here.")
], -1)
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "API's"),
  /*#__PURE__*/_createElementVNode("p", null, "Find here our latest API endpoints documentation.")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://cloudblast.canny.io/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
      /*#__PURE__*/_createElementVNode("strong", null, "Roadmap"),
      /*#__PURE__*/_createElementVNode("p", null, "Discover our future plans and exciting features in development now.")
    ])
  ])
], -1)
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Help Center"),
  /*#__PURE__*/_createElementVNode("p", null, "Get assistance, FAQs, and resources for troubleshooting and user support.")
], -1)
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Contact Us"),
  /*#__PURE__*/_createElementVNode("p", null, "Reach out for inquiries, support, or feedback; we're here to help.")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Solutions", -1)
const _hoisted_38 = { class: "container" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Gaming"),
  /*#__PURE__*/_createElementVNode("p", null, "Low latency, ddos protected game servers, perfect for your community.")
], -1)
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Trading & Forex"),
  /*#__PURE__*/_createElementVNode("p", null, "Extremely fast, low latency solutions for trading bots.")
], -1)
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Retail and E-Commerce"),
  /*#__PURE__*/_createElementVNode("p", null, "Fast and reliable solutions for retails and e-commerces stores.")
], -1)
const _hoisted_46 = { class: "col-md-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Streaming & Media"),
  /*#__PURE__*/_createElementVNode("p", null, "Scalable solutions for streaming services and media outlets")
], -1)
const _hoisted_48 = { class: "col-md-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Affiliate"),
  /*#__PURE__*/_createElementVNode("p", null, "Start earning a passive income with your affiliate link.")
], -1)
const _hoisted_50 = { class: "col-md-3" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Whitelabel Cloud"),
  /*#__PURE__*/_createElementVNode("p", null, "Start your own cloud business in few clicks and with no technical knowledge.")
], -1)
const _hoisted_52 = { class: "col-md-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Contact Us"),
  /*#__PURE__*/_createElementVNode("p", null, "Reach out for inquiries, support, or feedback; we're here to help.")
], -1)
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "main-dropdown-menu-wrapper" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "About Us"),
  /*#__PURE__*/_createElementVNode("p", null, "Discover more about us, our datacenters and partners.")
], -1)
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-3 align-self-center\"><div class=\"contact-btn-wrapper\"><a href=\"https://console.cloudblast.io/\"><img src=\"" + _imports_8 + "\" alt=\"headere-contact-btn-icon\"></a><a href=\"https://console.cloudblast.io/\" class=\"btn-style transparent material-bubble btn-arrow\"><span style=\"font-weight:500;font-size:18px;color:#fff;\">Console <svg width=\"8\" height=\"12\" viewBox=\"0 0 8 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.00002 0.710632C0.61002 1.10063 0.61002 1.73063 1.00002 2.12063L4.88002 6.00063L1.00002 9.88063C0.61002 10.2706 0.61002 10.9006 1.00002 11.2906C1.39002 11.6806 2.02002 11.6806 2.41002 11.2906L7.00002 6.70063C7.39002 6.31063 7.39002 5.68063 7.00002 5.29063L2.41002 0.700632C2.03002 0.320632 1.39002 0.320632 1.00002 0.710632Z\" fill=\"white\"></path></svg></span></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PromotionalPopup = _resolveComponent("PromotionalPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["top-bar", { 'active': _ctx.topbarActive }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("a", {
            href: "#",
            class: "top-bar-close-icon",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.topbarCloseBtn && _ctx.topbarCloseBtn(...args)))
          }, _hoisted_5)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["header", { 'active': _ctx.activeIndex }])
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_RouterLink, {
                  to: "/",
                  class: "logo logocloud"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createElementVNode("a", {
                  href: "#",
                  id: "hamburger",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addMenuClass && _ctx.addMenuClass(...args))),
                  class: _normalizeClass({ 'active': _ctx.isMenuActive })
                }, _hoisted_12, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: _normalizeClass(["menu-wrapper", { 'active': _ctx.isMenuActive }])
              }, [
                _createElementVNode("a", {
                  href: "#",
                  id: "cross-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeMenu()))
                }, _hoisted_15),
                _createElementVNode("ul", _hoisted_16, [
                  _createElementVNode("li", {
                    class: "dropdown",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleLiClick(1)))
                  }, [
                    _hoisted_17,
                    _createElementVNode("div", {
                      class: _normalizeClass(["dropdown-menu", { 'active': _ctx.activeIndex === 1 }])
                    }, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createVNode(_component_RouterLink, { to: "/pricing" }, {
                                    default: _withCtx(() => [
                                      _hoisted_27
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_RouterLink, { to: "/blog/1" }, {
                                    default: _withCtx(() => [
                                      _hoisted_29
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createVNode(_component_RouterLink, { to: "/api" }, {
                                    default: _withCtx(() => [
                                      _hoisted_31
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _hoisted_32,
                                _createElementVNode("div", _hoisted_33, [
                                  _createVNode(_component_RouterLink, { to: "/help" }, {
                                    default: _withCtx(() => [
                                      _hoisted_34
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_component_RouterLink, { to: "/contact" }, {
                                    default: _withCtx(() => [
                                      _hoisted_36
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ], 2)
                  ]),
                  _createElementVNode("li", {
                    class: "dropdown",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleLiClick(2)))
                  }, [
                    _hoisted_37,
                    _createElementVNode("div", {
                      class: _normalizeClass(["dropdown-menu", { 'active': _ctx.activeIndex === 2 }])
                    }, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(_component_RouterLink, { to: "/article/Gaming-Solutions" }, {
                              default: _withCtx(() => [
                                _hoisted_41
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(_component_RouterLink, { to: "/article/Elevate-Your-Trading-to-the-Next-Level-with-CloudBlast" }, {
                              default: _withCtx(() => [
                                _hoisted_43
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(_component_RouterLink, { to: "/article/Retail-and-E-Commerce-Solutions" }, {
                              default: _withCtx(() => [
                                _hoisted_45
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_RouterLink, { to: "/article/Streaming-&-Media-Solutions" }, {
                              default: _withCtx(() => [
                                _hoisted_47
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createVNode(_component_RouterLink, { to: "/affiliate" }, {
                              default: _withCtx(() => [
                                _hoisted_49
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode(_component_RouterLink, { to: "/whitelabel" }, {
                              default: _withCtx(() => [
                                _hoisted_51
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_component_RouterLink, { to: "/contact" }, {
                              default: _withCtx(() => [
                                _hoisted_53
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_RouterLink, { to: "/about" }, {
                              default: _withCtx(() => [
                                _hoisted_55
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ], 2)
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/pricing",
                      class: "menueffect"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Pricing")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/blog/1",
                      class: "menueffect"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Blog")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_RouterLink, {
                      to: "/about",
                      class: "menueffect"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("About Us")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ], 2)
            ]),
            _hoisted_56
          ])
        ])
      ], 2)
    ]),
    _createVNode(_component_PromotionalPopup)
  ], 64))
}